import Icon from '../../../../components/TooltipIcon';
import { CustomProperty } from '../../../properties/propertiesApi';

export const renderTypeColumnBody = (property: CustomProperty) => {
  let tooltip;

  if (property.type === 'enumeration') tooltip = 'Enumeration is an array (list) of objects (group of properties)';
  if (property.type === 'bool') tooltip = 'Boolean is a data type that denotes either true or false';
  if (property.type === 'collection') tooltip = 'Collection is an array of objects (group of properties)';
  return (
    <>
      {property.type} <Icon id={`${property.key}-2`} tooltip={tooltip} />
    </>
  );
};

export default renderTypeColumnBody;
